// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialog_root__2OwBq","hidden":"Dialog_hidden__1n6f3","scroll":"Dialog_scroll__5rMBL","dark":"Dialog_dark__1P6V4","light":"Dialog_light__3gf3a"};